import { z } from "zod";

import {
  CONDITION_TYPE,
  EFFECT_TYPE,
  TYPE_BUILDABLE,
  TYPE_CANCEL,
  TYPE_DROPPABLE,
  TYPE_INSTANCE,
  TYPE_ROOT_DROPPABLE,
} from "../constants.ts";

const conditionOrEffect = z.union([z.literal(CONDITION_TYPE), z.literal(EFFECT_TYPE)]);

const instanceIdentifier = z.object({
  type: z.literal(TYPE_INSTANCE),
  ruleType: conditionOrEffect,
  id: z.number(),
  typeId: z.string(),
});

const buildableIdentifier = z.object({
  type: z.literal(TYPE_BUILDABLE),
  nodeId: z.number(),
  ruleType: conditionOrEffect,
  typeId: z.string(),
});

const droppableIdentifier = z.object({
  type: z.literal(TYPE_DROPPABLE),
  ruleType: conditionOrEffect,
  id: z.number(),
  typeId: z.string(),
});

const rootDroppableIdentifier = z.object({
  type: z.literal(TYPE_ROOT_DROPPABLE),
  ruleType: conditionOrEffect,
});

const cancelDropzone = z.object({
  type: z.literal(TYPE_CANCEL),
});

export const draggableDataSchema = z.object({
  rule: z.discriminatedUnion("type", [buildableIdentifier, instanceIdentifier]),
  title: z.string().optional(),
});
export type DraggableData = z.infer<typeof draggableDataSchema>;

export const droppableDataSchema = z.object({
  rule: z.discriminatedUnion("type", [
    droppableIdentifier,
    instanceIdentifier,
    rootDroppableIdentifier,
    cancelDropzone,
  ]),
  disabled: z.boolean().optional(),
});
export type DroppableData = z.infer<typeof droppableDataSchema>;
